/**
 * Sum statement history data together if it has the same end_date
 * @param {InsightStatementHistoryData[]} data
 * @returns {InsightStatementHistoryData[]} summed data
 */
export const sumStatementHistoryData = (
    data: InsightStatementHistoryData[],
): InsightStatementHistoryData[] => {
    const map = data.reduce(
        (
            acc: Map<string, InsightStatementHistoryData>,
            statementHistory: InsightStatementHistoryData,
        ): Map<string, InsightStatementHistoryData> => {
            const key = statementHistory.period.end_date;

            if (statementHistory === undefined || !key) {
                return acc;
            }

            const current = acc.get(key);

            if (current === undefined) {
                acc.set(key, statementHistory);
            } else {
                let nextPlays = null;

                if (current.plays === null && current.plays !== undefined) {
                    if (statementHistory.plays) {
                        nextPlays = statementHistory.plays;
                    }
                } else if (
                    statementHistory.plays === null ||
                    statementHistory.plays === undefined
                ) {
                    nextPlays = current.plays;
                } else {
                    nextPlays = current?.plays ?? 0 + statementHistory.plays;
                }

                let nextEarnings = null;

                if (current.earnings === null) {
                    if (statementHistory.earnings !== null) {
                        nextEarnings = statementHistory.earnings;
                    }
                } else if (
                    statementHistory.earnings === null ||
                    statementHistory.earnings === undefined
                ) {
                    nextEarnings = current.earnings;
                } else {
                    nextEarnings =
                        current?.earnings ?? 0 + statementHistory.earnings;
                }

                const next = {
                    earnings: nextEarnings,
                    plays: nextPlays,
                    period: statementHistory.period,
                };

                acc.set(key, next);
            }

            return acc;
        },
        new Map<string, InsightStatementHistoryData>(),
    );

    return Array.from(map.values());
};
